import './TestScreen.scss';
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../shared/services";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import {IAPIResponseType} from "../../shared/models/api.model";
import {Download} from "@mui/icons-material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import TestFiltersComponent from "./test-filters/TestFiltersComponent";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import {IRootReducerState} from "../../store/reducers";
import SearchComponent from "../../shared/components/search/SearchComponent";
import _ from "lodash";
import {Link} from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import commonService from "../../shared/services/common.service";
import TestListTableComponent from "./test-list-table/TestListComponent";
import ReorderIcon from "@mui/icons-material/Reorder";

const FiltersInitialState: any = {
    search: '',
    sampleTypeObjs: [],
    sampleTypes: [],
    sampleCollectionDeviceObjs: [],
    sampleCollectionDevices: [],
    createdByObjs: [],
    createdByIds: [],
    statuses: [],
    statusesObjs: [],
    startDate: '',
    endDate: ''
}

const FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS = ['statusesObjs', 'createdByObjs', 'sampleTypeObjs', 'sampleCollectionDeviceObjs'];

const TestListScreen = () => {

    const [isCSVDownloading, setIsCSVDownloading] = useState(false);
    const [showFilterDrawer, setShowFiltersDrawer] = useState<boolean>(false);
    const dispatch = useDispatch();
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const {
        facilityStatusList,
        // sampleTypesList, equipmentTypeList,
        sampleTypeWithCollectionDevices,
        userList
    } = useSelector((state: IRootReducerState) => state.staticData);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    useEffect(() => {
        dispatch(setCurrentNavParams("Test", "Test", undefined));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const downloadCSV = useCallback(() => {
        const payload = {...filterData};
        setIsCSVDownloading(true);
        CommonService._test.downloadTestPanelCSV(payload)
            .then((response: IAPIResponseType<any>) => {
                setIsCSVDownloading(false);
                if (response && response?.data && response?.data?.attachmentUrl) {
                    CommonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title || 'testList', 'csv');
                }
            })
            .catch((error: any) => {
                setIsCSVDownloading(false);
            });
    }, [filterData]);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
                startDate: queryParamData.startDate || '',
                endDate: queryParamData.endDate || '',
            };
            if (queryParamData?.statuses?.length) {
                data['statuses'] = queryParamData.statuses.split(',') || [];
            }
            data['statusesObjs'] = facilityStatusList?.filter((item: any) => data['statuses']?.includes(item?.code));

            if (queryParamData?.createdByIds?.length) {
                data['createdByIds'] = queryParamData.createdByIds.split(',') || [];
            }
            data['createdByObjs'] = userList?.filter((item: any) => data['createdByIds']?.includes(item?.id?.toString()));

            if (queryParamData?.sampleTypes?.length) {
                data['sampleTypes'] = queryParamData.sampleTypes.split(',') || [];
            }
            // data['sampleTypeObjs'] = sampleTypesList?.filter((item: any) => data['sampleTypes']?.includes(item?.code));
            data['sampleTypeObjs'] = sampleTypeWithCollectionDevices?.filter((item: any) => data['sampleTypes']?.includes(item?.sampleType));


            if (queryParamData?.sampleCollectionDevices?.length) {
                data['sampleCollectionDevices'] = queryParamData.sampleCollectionDevices.split(',') || [];
            }
            // data['sampleCollectionDeviceObjs'] = equipmentTypeList?.filter((item: any) => data['sampleCollectionDevices']?.includes(item?.code));
            const uniqueSampleDevices = commonService.extractCollectionDevicesFromSampleType(queryParamData?.sampleTypes?.split(',') || [], sampleTypeWithCollectionDevices)
            data['sampleCollectionDeviceObjs'] = uniqueSampleDevices;
            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData, facilityStatusList, userList, sampleTypeWithCollectionDevices]);

    const applyFilters = useCallback((filterData: any) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            ...filterData
        }));
        setShowFiltersDrawer(false);
    }, []);

    useEffect(() => {
        CommonService.mapFilterDataToQueryParams(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS);
    }, [filterData]);

    const clearAllFilters = useCallback(() => {
        setFilterData(_.cloneDeep(FiltersInitialState));
    }, []);

    return (
        <div className="test-list-screen screen">
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search Test"}
                                id="search_input"
                                placeholder={"Search by test name"}
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>
                        <div className="page-extra-options">
                            {
                                CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 &&
                                <ButtonComponent
                                    type="button"
                                    id="clear_all_filters"
                                    color={"secondary"}
                                    variant={"text"}
                                    fullWidth={false}
                                    handleClick={clearAllFilters}
                                >
                                    Clear All
                                </ButtonComponent>
                            }
                            <ButtonComponent
                                type="button"
                                id="csv_btn"
                                color={"primary"}
                                variant={"outlined"}
                                fullWidth={false}
                                handleClick={() => setShowFiltersDrawer(true)}
                                startIcon={<FilterAltIcon/>}>
                                Filters {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 ? `( ${CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS)} )` : ''}
                            </ButtonComponent>
                            {commonService.checkAccess('Test', 'testPanelList', currentUser?.userAccessModules) &&
                                <Link to={CommonService._routeConfig.TestPanelListRoute()}>
                                    <ButtonComponent
                                        type="button"
                                        id="bulk_test_order_btn"
                                        color={"primary"}
                                        variant={"outlined"}
                                        fullWidth={false}
                                        startIcon={<ReorderIcon/>}
                                    >
                                        Test Panel
                                    </ButtonComponent>
                                </Link>
                            }
                            {
                                commonService.checkAccess('Test', 'testCsvDownload', currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    id="csv_btn"
                                    color={"secondary"}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    isLoading={isCSVDownloading}
                                    handleClick={downloadCSV}
                                    disabled={isCSVDownloading}
                                    startIcon={<Download/>}
                                >
                                    CSV
                                </ButtonComponent>
                            }
                            {commonService.checkAccess('Test', 'addTest', currentUser?.userAccessModules) &&
                                <Link to={CommonService._routeConfig.TestCreateRoute()}>
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"contained"}
                                        id="add_test_btn"
                                        startIcon={<AddIcon/>}
                                    >
                                        New Test
                                    </ButtonComponent>
                                </Link>
                            }
                        </div>
                    </div>
                    <>
                        <TestListTableComponent filterData={filterData}/>
                    </>
                </div>
            </div>
            <DrawerComponent open={showFilterDrawer}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             className={"drawer-wrapper"}
                             onClose={() => setShowFiltersDrawer(false)}
            >
                <TestFiltersComponent filtersData={filterData} onFiltersApply={applyFilters}
                                      clearAllFilters={clearAllFilters}/>
            </DrawerComponent>
        </div>
    )
};
export default TestListScreen;
